import parseURL from '../parseURL';
import toURL from '../toURL';

/**
 * Generates listing page URL, attach query parameters to url with parameters
 *
 * @example
 * generateListingUrl(
 *      '/vacation-rental/p4587083?uni_id=5239115',
 *      {
 *          adultsCount: 2
 *      }
 * );
 * // returns
 * // '/vacation-rental/p4587083?adultsCount=2&uni_id=5239115',
 *
 * @param {string} listingUrl - listing page url
 * @param {object} options - query parameters that should be added to listingUrl
 * @returns {string} listing page url with extra query parameters
 */
export default function generateListingUrl(listingUrl, options) {
    const listingRequest = {
        ...parseURL(listingUrl),
        ...options
    };

    return toURL(listingRequest);
}
